import { type Theme } from '@mui/material/styles'
import { getCategoryColor } from '../../../../core/utils/CategoryUtil'
import { getLayoutConfig } from './layout'
import type { InsightsInstanceSlotData } from '../../../../core/types/InsightsInstanceSlotData'

export const getDonutChartColors = (
  variant: string | null,
  blockData: InsightsInstanceSlotData,
  theme: Theme,
): [string, string] => {
  const layouts = getLayoutConfig(theme)
  const variantConfig = layouts[variant as keyof ReturnType<typeof getLayoutConfig>] as
    | { dynamicPrimary: string; secondaryColor: string }
    | { secondaryColor: string }
    | { colors: [string, string] }

  if ('dynamicPrimary' in variantConfig && variantConfig.dynamicPrimary === 'creditUtilization') {
    const utilization = Number(blockData.main?.value ?? 0)
    const primaryColor = utilization > 30 ? theme.palette.error.main : theme.palette.warning.main
    return [primaryColor, variantConfig.secondaryColor]
  }

  if ('secondaryColor' in variantConfig) {
    const categoryColor = getCategoryColor(blockData.category_guid ?? '', theme)
    return [categoryColor, variantConfig.secondaryColor]
  }

  return variantConfig.colors
}
